import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import FAQ from '@src/components/DisposalPage/FAQ'
import SustainabilityDashboardPromo from '@src/components/DisposalPage/SustainabilityDashboardPromo'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/industrial-alcohol-disposal-page.module.css'
// eslint-disable-next-line import/extensions
import industrial from '../../json/industrial-alcohol-disposal-data.json'

const industrialServiceData = {
  name: 'Industrial Alcohol Disposal and Reclamation',
  description:
    'Sustainable industrial alcohol disposal and reclamation nationwide. Dimension recovers spent ethanol, isopropyl alcohol, and methanol at certified facilities, with rebates for high-quality material. Pricing from $100 per service.',
  serviceType: 'Industrial Alcohol Disposal and Reclamation',
  url: 'https://getdimension.com/industrial-alcohol-disposal',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Ethanol Disposal and Reclamation' },
    { name: 'Isopropyl Alcohol (IPA) Disposal' },
    { name: 'Methanol Disposal' },
    { name: 'Spent Solvent Reclamation' },
    { name: 'High-Quality Alcohol Rebate Program' },
  ],
}

const industrialFAQData = {
  questions: industrial.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function IndustrialAlcoholDisposal() {
  return (
    <>
      <Head>
        <title>Industrial Alcohol Disposal &amp; Reclamation | Dimension</title>
        <meta
          name="description"
          content="Industrial alcohol disposal and reclamation nationwide. Dimension recovers spent ethanol, isopropyl alcohol, and methanol at certified facilities, with rebates for high-quality material. Pricing from $100 per service."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/industrial-alcohol-disposal" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={industrialServiceData} />
        <SchemaMarkup type="FAQPage" data={industrialFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="beverage"
          heading={industrial.pitch.heading}
          material={industrial.pitch.material}
          pitchText={industrial.pitch.pitchText}
          ctaLink={industrial.pitch.ctaLink}
          ctaText={industrial.pitch.ctaText}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Clients />
        <FeatureList {...industrial.solutions} />
        <SustainabilityDashboardPromo />
        <FeatureList {...industrial.benefits} />
        <Approach {...industrial.approach} />
        <FAQ {...industrial.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Flammable Waste Disposal',
              href: '/flammable-waste-disposal',
              description:
                'Compliant disposal of flammable solvents, fuels, and other ignitable materials for businesses.',
            },
            {
              label: 'Hazardous Waste Disposal',
              href: '/hazardous-waste-disposal',
              description:
                'Safe disposal of chemical waste, solvents, and other hazardous materials nationwide.',
            },
            {
              label: 'Alcoholic Beverage Disposal',
              href: '/alcoholic-beverage-disposal',
              description:
                'Compliant destruction and recycling of beer, wine, spirits, and other alcoholic beverages.',
            },
            {
              label: 'Lab Pack Services',
              href: '/lab-pack-services',
              description:
                'Safe packing, transport, and disposal of laboratory chemicals and small-container waste.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default IndustrialAlcoholDisposal
